module.exports = __webpack_public_path__ + "as.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/as.svg
// module id = 423
// module chunks = 0